interface StatCardProps {
  title: string;
  value: string;
  subValue?: string;
  subLabel?: string;
}

export function StatCard({ title, value, subValue, subLabel }: StatCardProps) {
  return (
    <div className="flex flex-col gap-2 w-full text-white bg-[#191714] border border-[#352F28] p-5 rounded-md">
      <span className="text-sm font-semibold">{title}</span>
      <span className="text-2xl font-bold text-brand-primary">{value}</span>
      {subValue && (
        <span className="text-xs text-white/60">
          {subLabel ? `${subLabel}: ` : ''}
          {subValue}
        </span>
      )}
    </div>
  );
}
